import type { SVGProps } from 'react';

export const SvgIconCategory170 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.875 9.125H5.875C5.32272 9.125 4.875 9.57272 4.875 10.125V25.125C4.875 25.6773 5.32272 26.125 5.875 26.125H27.875C28.4273 26.125 28.875 25.6773 28.875 25.125V10.125C28.875 9.57272 28.4273 9.125 27.875 9.125Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.875 3.125L16.875 9.125L22.875 3.125"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.375 16.125C25.2034 16.125 25.875 15.4534 25.875 14.625C25.875 13.7966 25.2034 13.125 24.375 13.125C23.5466 13.125 22.875 13.7966 22.875 14.625C22.875 15.4534 23.5466 16.125 24.375 16.125Z"
      fill="black"
    />
    <path
      d="M24.375 22.125C25.2034 22.125 25.875 21.4534 25.875 20.625C25.875 19.7966 25.2034 19.125 24.375 19.125C23.5466 19.125 22.875 19.7966 22.875 20.625C22.875 21.4534 23.5466 22.125 24.375 22.125Z"
      fill="black"
    />
    <path d="M19.875 26.125V9.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
